import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import PriceSwitcher from "./PriceSwitcher";
import PatternBestOffer from "../images/discover/pattern-best-offer.png";
import IconCheck from "../images/discover/icon-check.png";
import PartnersUbiwan from "../images/partners/ubiwan-partner.png";
import PartnersSpartes from "../images/partners/spartes-partner.png";

function PricesTransporteur({ defaultType, onPaymentAbonnement, onPaymentCB }) {
  const [activeTab, setActiveTab] = useState(defaultType || "abonnements");

  return (
    <>
      <div className="discover-section text-center mb-4">
        <h2 className="mb-4">
          Nos tarifs pour <span>les transporteurs</span>
        </h2>
        <p className="discover-section-price-presentation-subtitle">
          SoluSpots vous propose différentes offres afin de répondre au mieux à
          vos besoins. <br />
          <span className="banner-title-colored">
            Choisissez celle qui vous correspond le mieux :
          </span>
        </p>
        <PriceSwitcher activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>

      {activeTab === "packs" && (
        <>
          <Row className="justify-content-center">
            <Col xs={12} md={9} xl={6} className="my-2 text-center">
              <p className="discover-section-price-presentation-subtitle">
                <strong>
                  Publiez en toute liberté, quand vous le souhaitez&nbsp;!
                </strong>
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col xs={12} md={6} xl={5} className="my-4">
              <div className="discover-section-price-cards">
                <h3 className="discover-section-price-cards-pack-title">
                  <span>PACK 15</span>
                </h3>
                <h4 className="discover-section-price-cards-title">
                  Spotmonnaies
                </h4>
                <p className="discover-section-price-cards-subtitle">
                  Une annonce pour une date
                  <br />
                  coûte 1 Spotmonnaie
                </p>
                <div className="discover-section-price-cards-separator"></div>
                <p className="discover-section-price-cards-number">
                  <span className="discover-section-price-cards-number-special">
                    225 € <sup>HT*</sup>
                  </span>
                  <br />
                  <small>* soit 15 € HT / annonce</small>
                  <br />
                  <small className="promo-crossed">
                    + 99 € HT de frais uniques d'inscription
                  </small>
                </p>
                <div>
                  <div className="btn btn-danger">
                    Frais d’inscription OFFERTS&nbsp;!
                  </div>
                </div>
                <div className="discover-section-price-cards-separator"></div>
                <p className="mt-2">
                  Pour vos besoins ponctuels, publiez sans engagement avec un
                  pack pratique et flexible.
                </p>
                <div className="mt-4">
                  {onPaymentCB ? (
                    <a
                      className="solu-btn solu-btn-primary"
                      onClick={() => onPaymentCB("pack15")}
                    >
                      Je choisis le PACK 15
                    </a>
                  ) : (
                    <Link
                      to="/inscription"
                      className="solu-btn solu-btn-primary"
                    >
                      Je choisis le PACK 15
                    </Link>
                  )}
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} xl={5} className="my-4">
              <div className="discover-section-price-cards">
                <div className="discover-section-price-cards-shape">
                  <img src={PatternBestOffer} alt="" />
                  <span className="discover-section-price-cards-shape-title">
                    Le plus avantageux
                  </span>
                </div>
                <h3 className="discover-section-price-cards-pack-title">
                  <span>PACK 30</span>
                </h3>
                <h4 className="discover-section-price-cards-title">
                  Spotmonnaies
                </h4>
                <p className="discover-section-price-cards-subtitle">
                  Une annonce pour une date
                  <br />
                  coûte 1 Spotmonnaie
                </p>
                <div className="discover-section-price-cards-separator"></div>
                <p className="discover-section-price-cards-number">
                  <span className="discover-section-price-cards-number-special">
                    300 € <sup>HT*</sup>
                  </span>
                  <br />
                  <small>* soit 10 € HT / annonce</small>
                  <br />
                  <small className="promo-crossed">
                    + 99 € HT de frais uniques d'inscription
                  </small>
                </p>
                <div>
                  <div className="btn btn-danger">
                    Frais d’inscription OFFERTS&nbsp;!
                  </div>
                </div>
                <div className="discover-section-price-cards-separator"></div>
                <p className="mt-2">
                  Pour vos besoins ponctuels, publiez sans engagement avec un
                  pack pratique et flexible.
                </p>
                <div className="mt-4">
                  {onPaymentCB ? (
                    <a
                      className="solu-btn solu-btn-primary"
                      onClick={() => onPaymentCB("pack30")}
                    >
                      Je choisis le PACK 30
                    </a>
                  ) : (
                    <Link
                      to="/inscription"
                      className="solu-btn solu-btn-primary"
                    >
                      Je choisis le PACK 30
                    </Link>
                  )}
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={12} xl={10} className="my-4">
              <div className="discover-section-price-benefits">
                <h3 className="discover-section-price-benefits-title">
                  <span>
                    AVEC LE PACK, <span>VOUS BÉNÉFICIEZ DE :</span>
                  </span>
                </h3>
                <Row className="text-center">
                  <Col md={4}>
                    <img src={IconCheck} alt="" />
                    <h4>Flexibilité</h4>
                    <p>Achat selon vos besoins, sans engagement</p>
                  </Col>
                  <Col md={4}>
                    <img src={IconCheck} alt="" />
                    <h4>Tarification dégressive</h4>
                    <p>
                      Plus vous achetez de packs, plus vous économisez&nbsp;!
                    </p>
                  </Col>
                  <Col md={4}>
                    <img src={IconCheck} alt="" />
                    <h4>Simplicité</h4>
                    <p>Une annonce pour une date coûte 1&nbsp;Spotmonnaie</p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </>
      )}

      {activeTab === "abonnements" && (
        <>
          <Row className="justify-content-center">
            <Col xs={12} md={9} xl={6} className="my-2 text-center">
              <p className="discover-section-price-presentation-subtitle">
                <strong>
                  Publiez en toute liberté, sans limite, et profitez de services
                  premium pour simplifier votre gestion avec nos abonnements
                  Sérénité&nbsp;!
                </strong>
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col xs={12} md={6} xl={5} className="my-4">
              <div className="discover-section-price-cards">
                <h3 className="discover-section-price-cards-pack-title">
                  <span>12 MOIS</span>
                </h3>
                <div className="discover-section-price-cards-separator"></div>
                <div className="discover-section-price-cards-number">
                  <div className="discover-section-price-cards-number-special">
                    249,99€
                    <br />
                    <sup>HT/mois*</sup>
                  </div>
                  <div>
                    <small className="promo-crossed">
                      + 99 € HT de frais uniques d'inscription
                    </small>
                  </div>
                  <div>
                    <div className="btn btn-danger">
                      Frais d’inscription OFFERTS&nbsp;!
                    </div>
                  </div>
                  <div>
                    <strong>Pour un engagement 12 mois</strong>
                  </div>
                </div>
                <div className="mt-2">
                  {onPaymentAbonnement ? (
                    <a
                      className="solu-btn solu-btn-primary"
                      onClick={() => onPaymentAbonnement("serenite12")}
                    >
                      Je m'abonne 12 mois
                    </a>
                  ) : (
                    <Link
                      to="/inscription"
                      className="solu-btn solu-btn-primary"
                    >
                      Je m'abonne 12 mois
                    </Link>
                  )}
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} xl={5} className="my-4">
              <div className="discover-section-price-cards">
                <div className="discover-section-price-cards-shape">
                  <img src={PatternBestOffer} alt="" />
                  <span className="discover-section-price-cards-shape-title">
                    Le plus avantageux
                  </span>
                </div>
                <h3 className="discover-section-price-cards-pack-title">
                  <span>24 MOIS</span>
                </h3>
                <div className="discover-section-price-cards-separator"></div>
                <div className="discover-section-price-cards-number">
                  <div className="discover-section-price-cards-number-special">
                    199,99€
                    <br />
                    <sup>HT/mois*</sup>
                  </div>
                  <div>
                    <small className="promo-crossed">
                      + 99 € HT de frais uniques d'inscription
                    </small>
                  </div>
                  <div>
                    <div className="btn btn-danger">
                      Frais d’inscription OFFERTS&nbsp;!
                    </div>
                  </div>
                  <div>
                    <strong>Pour un engagement 24 mois</strong>
                  </div>
                </div>
                <div className="mt-2">
                  {onPaymentAbonnement ? (
                    <a
                      className="solu-btn solu-btn-primary"
                      onClick={() => onPaymentAbonnement("serenite24")}
                    >
                      Je m'abonne 24 mois
                    </a>
                  ) : (
                    <Link
                      to="/inscription"
                      className="solu-btn solu-btn-primary"
                    >
                      Je m'abonne 24 mois
                    </Link>
                  )}
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={12} xl={10} className="my-4">
              <div className="discover-section-price-benefits">
                <h3 className="discover-section-price-benefits-title">
                  <span>
                    EN VOUS ABONNANT, <span>VOUS BÉNÉFICIEZ DE :</span>
                  </span>
                </h3>
                <Row>
                  <Col md={6}>
                    <div className="discover-section-price-benefits-item">
                      <div
                        className="discover-section-price-benefits-item-icon"
                        style={{ alignContent: "start" }}
                      >
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <img src={PartnersUbiwan} alt="" />
                        <h4>Offre Ubiwan dès l’inscription </h4>
                        <p>
                          Suivi en temps réel des véhicules et optimisation des
                          trajets
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="discover-section-price-benefits-item">
                      <div
                        className="discover-section-price-benefits-item-icon"
                        style={{ alignContent: "start" }}
                      >
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <img src={PartnersSpartes} alt="" />
                        <h4>Offre SPARTES</h4>
                        <p>
                          Audit gratuit et optimisation des coûts sociaux et
                          fiscaux
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="discover-section-price-benefits-item">
                      <div className="discover-section-price-benefits-item-icon">
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <h4>Visibilité accrue</h4>
                        <p>pour chaque annonce</p>
                      </div>
                    </div>
                  </Col>
                  <Col
                    md={6}
                    xs={{ order: 5, span: 12 }}
                    className="order-5 order-md-4"
                  >
                    <div className="discover-section-price-benefits-item">
                      <div className="discover-section-price-benefits-item-icon">
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <h4>
                          Rapports de performance <span>(à venir)</span>
                        </h4>
                        <p>
                          mensuels sur la visibilité des annonces et leur
                          performance
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col
                    md={6}
                    xs={{ order: 4, span: 12 }}
                    className="order-4 order-md-5"
                  >
                    <div className="discover-section-price-benefits-item">
                      <div className="discover-section-price-benefits-item-icon">
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <h4>Support dédié</h4>
                        <p>pour toute question technique ou logistique</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default PricesTransporteur;
